import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";

// Supports weights 100-900
import "@fontsource-variable/roboto";

const poppinsFont = "Poppins, sans-serif";
const robotoFont = "Roboto Variable, sans-serif";

export const fonts = {
	heading: poppinsFont,
	paragraphs: robotoFont,
	forms: robotoFont,
	buttons: robotoFont,
	links: robotoFont,
	body: robotoFont,
};
